module.exports = {
    TOKEN_CREDENTIAL: 'tokenCredential',
    AGENT_INFO: 'agentInfo',
    IE_MAX_COOKIE_SIZE: 10234,
    COOKIE_PERCENTAGE_USAGE: 50,
    MAX_SESSIONS_SIZE_BEFORE_CURRENT: 2,
    SESSIONS_STATE: 'sessionsState'
};
